/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import FeatherWrapper from '../Wrapper'

const FeatherCheck: React.FunctionComponent = () => {
  return (
    <FeatherWrapper id="check" viewBox="0 0 18 13">
      <title>Icons/UI/ arrow-down Copy 5</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M1.92258898,5.24407768 C1.59715207,4.91864077 1.06951459,4.91864077 0.744077682,5.24407768 C0.418640773,5.56951459 0.418640773,6.09715207 0.744077682,6.42258898 L4.91074435,10.5892557 C5.23618126,10.9146926 5.76381874,10.9146926 6.08925565,10.5892557 L15.2559223,1.42258898 C15.5813592,1.09715207 15.5813592,0.569514592 15.2559223,0.244077682 C14.9304854,-0.0813592274 14.4028479,-0.0813592274 14.077411,0.244077682 L5.5,8.8214887 L1.92258898,5.24407768 Z"
          id="path-1"
        ></path>
      </defs>
      <g
        id="V4-Time-tracking"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="hrs-tracking---multiple-cleans---3"
          transform="translate(-227.000000, -976.000000)"
        >
          <g id="Group-32" transform="translate(0.500000, 951.000000)">
            <g
              id="Group-11-Copy-8"
              transform="translate(215.500000, 11.000000)"
            >
              <g
                id="Icons/UI/-arrow-down-Copy-5"
                transform="translate(12.000000, 15.000000)"
              >
                <mask id="mask-2" fill="white">
                  <use href="#path-1"></use>
                </mask>
                <use
                  id="Shape"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="#FFFFFF"
                  href="#path-1"
                ></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </FeatherWrapper>
  )
}

export default React.memo(FeatherCheck)
